import React, { useContext, useRef, useState } from 'react';

import PageContext from '../../Context/PageContext';
import { HandleClasses, HandleStyles, Rnd } from 'react-rnd';

import $ from "jquery";
import { isMobile } from 'react-device-detect';
import { createCropCadreElementAction } from '../../history/element.history';

const CropCadreImageCard = (props: any) => {

  /*
    CropImageCard est un composant React interactif qui permet à l'utilisateur de rogner, déplacer et redimensionner 
    dynamiquement une image dans un cadre à l'aide de la bibliothèque react-rnd.
    Ce composant maintient à la fois :
    - l'affichage interactif (image rognée, déplacée/redimensionnée)
    - et une image "fixe" calée en arrière-plan (non-interactive), utilisée comme référence ou pour prévisualisation.
  
  
    Crop region : Rnd (resize + draggable) #1 > div (opacity 0.5) #2 > img full-size #3
    *************************************************
    *	Fixed part : we use zoom and translate		    *
    *   Rnd (fixed use to get transform position) #4*
    *		> div fixeRef (with clip-path) 	#5		      *
    *			> img width size and transform #6         *
    *                                               *
    *     **************  								          *
    *     *            *  								          *
    *     *            *  								          *
    *     *            *  								          *
    *     *            *  								          *
    *     **************  								          *
    *                  								              *
    *************************************************
      
    Crop region is use to select image fragmen in the cadre-element (with zoom or transform)
      #1 Rnd handle the zoom and movement
      #2 container for img with opacity
      #3 img in full size
      
    Fixeb part :
      #4 Fixed Rnd, just use for getting transform position
      #5 div container with clip-path
      #6 crop image with zoom and transform => is the representaiton of finish cadre-element transformation
      
  
    Fonctionnalités
    1. Déplacement de l’image
    Utilise Rnd pour permettre le drag.    
    Lors du drag, met à jour dynamiquement la transformation appliquée à l’image fixe à l'intérieur du cadre (transform: translate(...)).
    
    2. Redimensionnement (crop)
    Le redimensionnement ajuste dynamiquement la taille de l'image dans le cadre.    
    Les dimensions sont stockées :    
      en pixels (sizePX)    
      en pourcentages (sizePourcent), ce qui est utile pour la réactivité et le recalcul après zoom.
    
    3. Conservation de l’état du crop
    Lorsqu'on revient sur une image déjà manipulée, les valeurs précédentes de crop.translate, crop.sizePX, etc., sont utilisées pour réinitialiser le cadre et l’image au bon état.
    
    4. Deux calques RND
    Le calque supérieur est l’interactif (drag/resize).  
    Le calque inférieur est la version statique utilisée pour affichage.
    
    */

  const val = props.val;

  const { zoomValue, setZoomValue, selectedItem, objItems, addItem, history } = useContext(PageContext);

  //si il y a déjà eu un translate
  const [position, setPosition] = useState({ x: val.x + (val.cropCadre.translate.x != null ? val.cropCadre.translate.x : 0), y: val.y + (val.cropCadre.translate.y != null ? val.cropCadre.translate.y : 0) });

  const fixeRef = useRef<HTMLDivElement>(null);
  const fixeImg = useRef<HTMLImageElement>(null);
  const fixedRnd = useRef<Rnd>(null);

  const rafId = useRef<number | null>(null);
  const lastUpdate = useRef<number>(0);
  const MAX_FPS = 100; // ← ici tu règles
  const FRAME_TIME = 1000 / MAX_FPS; // 50 ms

  React.useEffect(() => {

    //item is the real element, val is the open crop cadre
    var item = objItems.find(item => item.id === val.originalId);

    var backPosition = { x: item.x, y: item.y, width: item.width, height: item.height, zoomValue, cropCadre: cloneCropCadre(item.cropCadre) }

    // composant démontage
    return () => {
      //history
      const action = createCropCadreElementAction(
        item,
        { addItem },
        backPosition,
        { x: item.x, y: item.y, width: item.width, height: item.height, zoomValue, cropCadre: cloneCropCadre(item.cropCadre) }
      );

      history.add(action);
    };

  }, [])

  React.useEffect(() => {
    return () => {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, []);

  function cloneCropCadre(data: any) {
    if (data == null) return null;

    return {
      sizePX: {
        width: data.sizePX?.width,
        height: data.sizePX?.height
      },

      sizePourcent: {
        width: data.sizePourcent?.width,
        height: data.sizePourcent?.height
      },

      transform: data.transform,

      translate: {
        x: data.translate?.x,
        y: data.translate?.y
      },

      isPushImg: data.isPushImg
    };
  }

  function subtractTranslate(translate1: any, translate2: any) {
    // Extraire les valeurs numériques
    //const regex = /translate\(([-\d.]+)px,\s*([-\d.]+)px\)/;
    const regex = /translate\(([-\d.eE]+)px,\s*([-\d.eE]+)px\)/;

    const match1 = translate1.match(regex);
    const match2 = translate2.match(regex);

    if (!match1 || !match2) {
      throw new Error("Format incorrect. Utiliser translate(xpx, ypx).");
    }

    // Convertir en nombres
    const x1 = parseFloat(match1[1]);
    const y1 = parseFloat(match1[2]);
    const x2 = parseFloat(match2[1]);
    const y2 = parseFloat(match2[2]);

    // Calculer la différence, round pour éviter les décimales à rallonge
    //const dx = parseFloat((x1 - x2).toFixed(3));
    //const dy = parseFloat((y1 - y2).toFixed(3));
    const dx = Math.round((x1 - x2));
    const dy = Math.round((y1 - y2));


    return `translate(${dx}px, ${dy}px)`;

  }

  function extractTranslate(translate1: any) {
    // Extraire les valeurs numériques
    // const regex = /translate\(([-\d.]+)px,\s*([-\d.]+)px\)/;
    //gère les exposants
    const regex = /translate\(([-\d.eE]+)px,\s*([-\d.eE]+)px\)/;

    const match1 = translate1.match(regex);

    if (!match1) {
      throw new Error("Format incorrect. Utiliser translate(xpx, ypx).");
    }

    // Convertir en nombres
    const x1 = parseFloat(parseFloat(match1[1]).toFixed(3));
    const y1 = parseFloat(parseFloat(match1[2]).toFixed(3));

    return { x: x1, y: y1 };

  }

  function getIntSize(size: any) {
    if (typeof size === 'string' && size.includes("px"))
      return parseInt(size.replace("px", ""))
    else return size
  }

  function moveFixedImg(elementTransform: any, position: any) {
    //the rnd parent which have the transform style set
    var fixeEl = fixeRef.current?.parentElement;

    //lorsque l'on sort du cadre elementTransform est vide, et les calculs qui suivent lève une exception
    if (elementTransform != "") {
      //var new_translate = subtractTranslate(elementTransform, fixeEl?.style.transform);
      //fixeEl?.style.transform ==> la position x et y de l'élement fixe donc, autant reprendre val.x et val.y
      //on utilisait le transform pour avoir ça position absolute

      var cx = Math.round(position.x - val.x);
      var cy = Math.round(position.y - val.y);

      var new_translate = "translate(" + cx + "px, " + cy + "px)";

      //get the image in
      if (fixeRef.current && fixeRef.current.children.length > 0) {
        (fixeRef.current.children[0] as HTMLElement).style.transform = new_translate;
        //(fixeRef.current.children[0] as HTMLElement).style.transform = "translate(-156px, -116px)";
      }
    }
  }

  /**/function onDragElement(e: any, position: any) {
    var t = "translate(" + position.x + "px, " + position.y + "px)";
    //moveFixedImg(e.srcElement.style.transform);
    moveFixedImg(t, position);
  }

  /*  onDrag peut être appelé : 100+, 200+, parfois 500 fois par seconde
      alors que ton écran ne peut afficher que ~60 frames/sec.
      Donc tu fais beaucoup plus de boulot que nécessaire.
      Pourquoi requestAnimationFrame est magique
      requestAnimationFrame (rAF) : s’aligne sur le rafraîchissement de l’écran

      garantit 1 appel max par frame, laisse le navigateur optimiser le rendu, évite les calculs inutiles entre deux frames
      Résultat : fluide + moins de CPU + moins de re-render */

  /*function onDragElement(e: any, position: any) {
    //console.log(e.srcElement.style.transform)
    //console.log(position)
    var t = "translate(" + position.x + "px, " + position.y + "px)";
    console.log("on drag")

    if (rafId.current !== null) return;

    //on dirait que ça créer des pb de synchronisation, une partie du code devient asynchrone donc c'est pas bon, surtout avec drag stop
    rafId.current = requestAnimationFrame(() => {
      //moveFixedImg(e.srcElement.style.transform);
      moveFixedImg(t, position);
      //console.log("on passe là")
      rafId.current = null;
    });


  }*/



  function onDragElementStop(e: any, position: any) {

    var fixeEl = fixeRef.current;

    //set Img in Cadre Position
    var item = objItems.find(item => item.id === val.originalId);

    if (!fixeEl) return;
    //si on drag en dehors de l'écran, transform est vide, alors on fait rien, pour revenir à l'ancienne position
    //on replace image fixe à sa position d'avant
    if (e.srcElement.style.transform == "") {
      if (fixeRef.current && fixeRef.current.children.length > 0) {
        (fixeRef.current.children[0] as HTMLElement).style.transform = item.cropCadre.transform;
      }

      return;
    }

    var grandeWidth = e.srcElement.offsetWidth;
    var grandeHeight = e.srcElement.offsetHeight;

    // Calcul des limites pour que la fixe reste visible
    var minX = val.x + fixeEl.offsetWidth - grandeWidth;
    var maxX = val.x;

    var minY = val.y + fixeEl.offsetHeight - grandeHeight;
    var maxY = val.y;

    //get max if draggable gone out of hte box
    //var clampedX = parseFloat(Math.max(minX, Math.min(maxX, position.x)).toFixed(3));
    //var clampedY = parseFloat(Math.max(minY, Math.min(maxY, position.y)).toFixed(3));

    var clampedX = Math.round(Math.max(minX, Math.min(maxX, position.x)));
    var clampedY = Math.round(Math.max(minY, Math.min(maxY, position.y)));

    //besoin d'arrondir, car splité en string avec regex (les exposants e-14 broke)
    position.x = clampedX;
    position.y = clampedY;

    //reset the position in the box
    setPosition({ x: clampedX, y: clampedY });

    //reset the fixed img as the draggable rnd we use as model
    moveFixedImg('translate(' + clampedX + 'px, ' + clampedY + 'px)', { x: clampedX, y: clampedY });

    var nTransform = subtractTranslate('translate(' + clampedX + 'px, ' + clampedY + 'px)', fixeRef.current?.parentElement?.style.transform);

    //item.style.transformImgIn = nTransform;
    item.cropCadre.transform = nTransform;
    $("#img-" + item.id).css('transform', nTransform);

    //set the decalage
    item.cropCadre.translate = extractTranslate(nTransform);

  }


  function onSizeElement(e: any, ref: any, delta: any, position: any) {

    if (fixeRef.current && fixeRef.current.children.length > 0) {

      //on passe par les pourcentage pour garantir les modifications futures
      let pourcentageHeightSize = 100 * ref.offsetHeight / parseInt(fixeRef.current?.parentElement?.style.height.replace('px', '')!) + '%';
      let pourcentageWidthSize = 100 * ref.offsetWidth / parseInt(fixeRef.current?.parentElement?.style.width.replace('px', '')!) + '%';
      (fixeRef.current.children[0] as HTMLElement).style.height = pourcentageHeightSize;
      (fixeRef.current.children[0] as HTMLElement).style.width = pourcentageWidthSize;

      //width is auto size

      //set Img in Cadre Position for save and css for immediate result
      let item = objItems.find(item => item.id === val.originalId);

      //{sizePX : {width, height}, sizePourcent  , translate {x, y}, transform}
      item.cropCadre.sizePX.width = ref.offsetWidth;
      item.cropCadre.sizePX.height = ref.offsetHeight;
      item.cropCadre.sizePourcent.width = pourcentageWidthSize;
      item.cropCadre.sizePourcent.height = pourcentageHeightSize;

      $("#img-" + item.id).height(pourcentageHeightSize);
      $("#img-" + item.id).width(pourcentageWidthSize);

      //set translate
      var fixeEl = fixeRef.current?.parentElement;
      var new_translate = subtractTranslate("translate(" + position.x + "px, " + position.y + "px)", fixeEl?.style.transform);

      //get the image in
      if (fixeRef.current && fixeRef.current.children.length > 0) {
        (fixeRef.current.children[0] as HTMLElement).style.transform = new_translate;
      }

      //set the decalage
      item.cropCadre.transform = new_translate;
      item.cropCadre.translate = extractTranslate(new_translate);

    }

  }


  const rhC: HandleClasses = {
    bottomLeft: "corner-resize-bottomLeft",
    bottomRight: "corner-resize-c",
    topLeft: "corner-resize-c",
    topRight: "corner-resize-c",
  }

  const cssProp: React.CSSProperties = {
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: '0 0 4px 1px rgba(57, 76, 96, .15), 0 0 0 1px rgba(43, 59, 74, .3)',
    zIndex: 999
  }

  const cssPropLine: React.CSSProperties = {
    backgroundColor: '#8b3dff',
    zIndex: 999
  }

  const epaisseurBordure = 6;
  const epaisseurBordureTopBottom = epaisseurBordure / 2;
  var sizeCornerResizeSize = isMobile ? 20 / zoomValue : 15 / zoomValue;
  var sizeCornerResizeAbsolute = sizeCornerResizeSize / 2;

  const cornerStyle: HandleStyles = {
    bottom: { ...cssPropLine, height: epaisseurBordure, bottom: -epaisseurBordureTopBottom },
    bottomLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
    bottomRight: { ...cssProp, right: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
    left: { ...cssPropLine, width: epaisseurBordure, left: -epaisseurBordureTopBottom },
    right: { ...cssPropLine, width: epaisseurBordure, right: -epaisseurBordureTopBottom },
    top: { ...cssPropLine, height: epaisseurBordure, top: -epaisseurBordureTopBottom },
    topLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
    topRight: { ...cssProp, right: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
  }

  return (
    <div style={{}}>
      <Rnd
        id={'crop-image'}
        resizeHandleStyles={cornerStyle}
        resizeHandleClasses={rhC}

        default={{
          x: val.x,
          y: val.y,
          //width: 'auto',
          width: val.cropCadre.sizePX.width != null ? val.cropCadre.sizePX.width : parseInt(val.width),
          height: val.cropCadre.sizePX.height != null ? val.cropCadre.sizePX.height : parseInt(val.height),
        }}
        style={{ zIndex: 99999 }}
        position={position}
        minWidth={parseInt(val.width)}
        minHeight={parseInt(val.height)}
        onDrag={(e, d) => { onDragElement(e, d) }}
        onDragStop={(e, d) => { onDragElementStop(e, d) }}
        onResize={(e, direction, ref, delta, position) => {
          onSizeElement(e, ref, delta, position);
        }}
        scale={zoomValue}
        lockAspectRatio={true}
        enableResizing={{ top: true, right: true, bottom: true, left: true, topRight: true, bottomRight: true, bottomLeft: true, topLeft: true }}
      >
        <div className="full-size-img-cadre-element" style={{ display: 'block', pointerEvents: "none", opacity: 0.5, height: '100%', width: '100%' }} >
          <img /*src={val.text === 'upload' ? val.src : "http://localhost:3000/studio" + val.src}*/ src={val.text === 'upload' ? val.src : process.env.REACT_APP_PUBLIC_URL + val.src}
            //prod => src={val.src}
            style={{
              pointerEvents: "none",
              height: '100%', width: '100%'
            }} />
        </div>
      </Rnd>
      <Rnd
        id={'unmoved-' + val.id}
        ref={fixedRnd}
        default={{
          x: val.x,
          y: val.y,
          width: val.width,
          height: val.height,
        }}
        style={{ zIndex: 99999, pointerEvents: 'none' }}
        scale={zoomValue}
        enableResizing={{ top: false, right: false, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}
        disableDragging={true}
      >
        <div ref={fixeRef} className="copy-img-cadre-element" style=
          {{
            clipPath: val.style["clip-path"] != null ? val.style["clip-path"] : "",
            position: 'absolute',
            height: val.height,
            width: val.width,
            zIndex: 99999999,
            pointerEvents: "none"
          }}>
          <img id='img-static' ref={fixeImg}
            //src={val.text === 'upload' ? val.src : "http://localhost:3000/studio" + val.src}
            src={val.text === 'upload' ? val.src : process.env.REACT_APP_PUBLIC_URL + val.src}

            style={{
              //si ratio
              height: val.cropCadre.sizePX.height != null ? val.cropCadre.sizePX.height : val.height,
              width: val.cropCadre.sizePX.width != null ? val.cropCadre.sizePX.width : val.width,
              transform: val.cropCadre.transform != null ? val.cropCadre.transform : '',
              willChange: 'transform',
              backfaceVisibility: 'hidden',
            }} />
        </div>
      </Rnd>
    </div>
  );
};

export default CropCadreImageCard;